// TODO: 10/08/23 if i have an estimate of 51 copper split bolts I should be able to augment to 70 - I can't. It only gives me room to 60. It does receive a 2 digit entry
// @ts-nocheck
function makeFenceObject(sessionObj) {
    const sessionObjectWithInts = makeSessionObjectWithInts(sessionObj)

    let FenceObject = {
        ...sessionObjectWithInts,
        sizeFt: 0,
        joins: 0,
        fencePosts: 0,
        reels: 0,
        spacingInPref: 0,

        generalFenceDescripRpt() {
            const that = this
            return fenceSummary(that)
        },
    }
    const sizeFt = getSizeInFeet(sessionObjectWithInts)
    const spacingInPref = getSpacingInPref(
        sessionObjectWithInts.unit,
        sessionObjectWithInts.spacing
    )

    FenceObject.sizeFt = sizeFt
    FenceObject.spacingInPref = spacingInPref
    FenceObject.joins = getJoins(sizeFt)
    FenceObject.fencePosts = getPosts(sizeFt, sessionObjectWithInts)
    FenceObject.reels = getReels(sizeFt, sessionObjectWithInts)

    return FenceObject
}

function makeSessionObjectWithInts(sessObject) {
    let stringedParams = ['map_posts', 'unit']

    let newObj = Object.keys(sessObject).reduce((acc, key) => {
        return stringedParams.includes(key)
            ? { ...acc, [key]: sessObject[key] }
            : { ...acc, [key]: parseInt(sessObject[key]) }
    }, {})

    //remove the unneeded for fence calc
    // eslint-disable-next-line no-unused-vars
    const { map_posts, ...rest } = newObj

    return rest
}

function getSizeInFeet({ unit, size }) {
    let toFeet = {
        feet: (size) => size,
        meters: (size) => Math.ceil(size * 3.280839895),
    }

    // console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&')
    // console.log('the getSizeInFeet units and size are ...', unit, size)
    // console.log('returning ', toFeet[unit](size))
    return toFeet[unit](size)
}
function getSpacingInPref(unit, spacing) {
    let toPref = {
        feet: (spacing) => spacing,
        meters: (spacing) => Math.round(spacing / 3.280839895),
    }

    return toPref[unit](spacing)
}

function getJoins(sizeFt) {
    return Math.floor(sizeFt / 1000) - 1 + (sizeFt % 1000 > 0 ? 1 : 0)
}

function getPosts(sizeFt, { spacing, ends, corners }) {
    const fencePosts = Math.ceil(sizeFt / spacing) - (ends - 1) - corners
    return fencePosts > 0 ? fencePosts : 1
}

function getReels(sizeFt, { strands }) {
    return Math.ceil((strands * sizeFt) / 1000)
}

function fenceSummary(that) {
    const {
        size,
        unit,
        spacingInPref,
        strands,
        joins,
        reels,
        fencePosts,
        color,
        kit,
        i_color,
    } = that

    let elementSummary = `\nThere will be ...\n`
    const colorsBraid = ['White', 'Black', 'Checkered']
    const colorsInsul = ['Black', 'White']
    const fenceElement = ['posts', 'corners', 'ends', 'gates']
    fenceElement.forEach((element) => {
        const firstLetter = element.slice(0, 1)
        const matsProp = firstLetter + '_mats'
        const braceProp = firstLetter + '_hbrace'
        const numOfElements =
            that[element] !== undefined ? that[element] : fencePosts
        const matsID = that[matsProp]
        const braceID = that[braceProp]

        const anElementSummary = getFenceElementSummary(
            element,
            numOfElements,
            matsID,
            braceID
        )
        elementSummary += anElementSummary
    })
    const strandTxt =
        strands === 1 ? `is ${strands} strand` : `are ${strands} strands`
    const joinTxt = joins === 0 ? 'no' : joins
    const puralTxt_join = joins === 1 ? 'join.' : 'joins.'
    const generalSummary = `\nThe fence has a perimeter of ${size} ${unit} using a post spacing of ${spacingInPref} ${unit}. \nThere ${strandTxt} and ${joinTxt} ${puralTxt_join} \nIt will need ${reels} ${colorsBraid[color]} reels.
    `

    const numOfGatesKits = kit === 0 ? 'No' : kit
    const pluralTxt_gate = kit === 1 ? ' is' : 's are'

    const miscSummary = `\n${numOfGatesKits} gate kit${pluralTxt_gate} required and all insulators are ${colorsInsul[i_color]}.`
    return generalSummary + elementSummary + miscSummary
}

function getFenceElementSummary(element, numOfElements, matsID, braceID) {
    const fenceElement = element.slice(0, -1)

    const mats = { 0: 'Wood/Pipe', 1: 'Tree' }
    const brace = { 0: 'Braid', 1: 'Wood', 2: 'None' } // { 0: 'None' , 1: 'Braid', 2: 'Wood',  }

    const pluralTxt = numOfElements == 1 ? '' : 's'
    let bracingTxt =
        brace[braceID] === 'None'
            ? `.\n`
            : ` using ${brace[braceID]} for the bracing material.\n`
    bracingTxt = fenceElement === 'post' ? `.\n` : bracingTxt

    return `${numOfElements} ${mats[matsID]} ${fenceElement}${pluralTxt}${bracingTxt}`
}

export default makeFenceObject
